import { Button } from "../../../components/ui/button";
import { navigate } from "../../../lib/router";
import { useLanguage } from "../../../contexts/LanguageContext";
import { landingLabels } from "../labels";

const Footer = () => {
  const { lang } = useLanguage();
  const t = landingLabels[lang].footer;
  const year = new Date().getFullYear();
  return (
    <footer className="bg-neutral-100">
      <hr className="border-neutral-200" />
      <div className="flex justify-center px-6">
        <div className="w-full max-w-screen-lg">
          <div className="py-8 flex flex-col-reverse sm:flex-row items-center justify-between gap-x-2 gap-y-5">
            <div className="text-muted-foreground flex flex-col sm:flex-row items-center gap-2">
              <span>&copy; {year} {t.rights}</span>
              <Button
                variant="ghost"
                size="micro"
                className="p-0 h-auto text-sm text-muted-foreground hover:underline"
                onClick={() => navigate("/politica-e-termos")}
              >
                {t.privacy}
              </Button>
            </div>
            <div className="max-w-xs w-full">
              <div className="mt-0 flex items-center justify-center sm:justify-end gap-2">
                <Button onClick={() => window.open('https://wa.me/5551991543108', '_blank')}>{t.whatsapp}</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
